function About() {
  return (
<section className="about" id="about">
      <div className="about-vis rv">
        <div className="about-img"></div>
        {/* <div className="about-qcard">
          <blockquote>
            Architects bring dreams into reality — the art and science of space,
            made human.
          </blockquote>
          <cite>Ar. Gajanan Shetkar · Founder, IPDI</cite>
        </div> */}
      </div>
      <div className="about-con">
        <div className="eyebrow rv">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text">Our Mission</span>
        </div>
        <h2 className="sec-title rv d1"  style={{ marginBottom: "1rem" }}>
          Education Built for <em>Real Practice</em>
        </h2>
        <p className="about-desc rv d2">
          IPDI was founded to bridge the critical gap between 
          <strong> academic training and industry readiness </strong>. Our
          structured programs are designed by working professionals — not
          textbooks — preparing architects and designers to thrive in
          multinational firms from day one.
        </p>
        <p className="about-desc rv d3">
          Beyond education, we're building India's most specialized 
          <strong> placement and hiring ecosystem </strong>  for the AEC sector —
          connecting skilled talent with firms, and colleges with industry.
        </p>
        <div className="pillars">
          <div className="pillar rv d1">
            <div className="p-icon">
              <svg viewBox="0 0 24 24">
                <path
                  d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
                />
              </svg>
            </div>
            <div className="p-name">Industry Curriculum</div>
            <p className="p-desc">
              Modules built by working professionals for real workflows.
            </p>
          </div>
          <div className="pillar rv d2">
            <div className="p-icon">
              <svg viewBox="0 0 24 24">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <div className="p-name">International Faculty</div>
            <p className="p-desc">
              Learn from experts across the US, Europe, and India.
            </p>
          </div>
          <div className="pillar rv d3">
            <div className="p-icon">
              <svg viewBox="0 0 24 24">
                <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
              </svg>
            </div>
            <div className="p-name">Live Exposure</div>
            <p className="p-desc">
              Site visits, live projects, and real industry briefs.
            </p>
          </div>
          <div className="pillar rv d3">
            <div className="p-icon">
              <svg viewBox="0 0 24 24">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 19 19 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 19 19 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                />
              </svg>
            </div>
            <div className="p-name">Career Support</div>
            <p className="p-desc">
              1-on-1 counselling, portfolio &amp; interview prep.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;



